export default __webpack_public_path__ + "static/media/error.08bd20aa.gif";